// extracted by mini-css-extract-plugin
module.exports = {"data":"DetailsItem_data__Dn1wl","delimiter":"DetailsItem_delimiter__8Kb6n"};